module.exports = __webpack_public_path__ + "static/media/appreciation-letter-img-1.0b493e06.jpg";